import React, { useEffect, useRef, useState } from "react";
import s from "./Impreso.module.css";

//servicios
import deliveryServices from "../../../../api/delivery/DeliveryService";

//Asstets
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import { Plantilla } from "./Plantilla";

//Materia;
import { Grid, CircularProgress } from "@mui/material";
import { useNotificationContext } from "../../../Notifications/CustomNotifications";

export const Impreso = () => {
  const notification = useNotificationContext();
  const params = useParams();
  const componentRef = useRef(null);
  const { t } = useTranslation();
  const [readyAssets, setReadyAssets] = useState(false);
  const [data, setData] = useState({});
  const navigate = useNavigate();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => navigate("../remitos"),
  });

  useEffect(() => {
    console.log("🔍 [Impreso] ID enviado al endpoint para imprimir:", params.id); 
    deliveryServices
      .getDeliveryNoteById(params.id)
      .then((response) => {
        console.log("✅ [Impreso] Remito obtenido para imprimir:", JSON.stringify(response, null, 2));
        console.log("✅ [Impreso] Fecha del remito (date):", response.date);
        setData(response);
      })
      .catch((error) => {
        console.error("❌ [Impreso] Error al obtener remito:", error);
        notification.error("Error ep", error.message);
      });
  }, [notification, params.id]);

  useEffect(() => {
    if (data?.id && readyAssets) {
      handlePrint();
    }
  }, [data?.id, readyAssets]);

  return (
    <Grid container className={s.container}>
      {!data?.id && (
        <Grid item xs={10} className={s.loader}>
          <CircularProgress size={"4rem"} />
          <p>{t("loading")}</p>
        </Grid>
      )}
      {data?.id && (
        <div ref={componentRef} className={s.forPrint}>
          <Plantilla data={data} assetsReady={setReadyAssets} />
        </div>
      )}
    </Grid>
  );
};
